import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/i18n'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		userDevice: 0,
		language: 0,
		deviceId: null,
	},
	getters: {
		userDevice: state => state.userDevice,
		language: state => state.language,
		deviceId: state => state.deviceId,
	},
	mutations: {
		setUserDevice(state, userDevice) {
			state.userDevice = userDevice
		},
		setLanguage(state, language) {
			state.language = language
			i18n.locale = language
		},
		setDeviceId(state, deviceId) {
			state.deviceId = deviceId
		},
	},
})
